import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule, LOCALE_ID} from '@angular/core';

import {AuthGuard} from './shared/auth.guard';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app.routing';
import {LoaderComponent} from './http-utility/loader/loader.component';
import {LoaderService} from './http-utility/loader/loader.service';
import {PopupComponent} from './custom-component/popup/popup.component';
import {registerLocaleData} from '@angular/common';
import localeIt from '@angular/common/locales/it';
import {HttpService} from './http-utility/http.service';

registerLocaleData(localeIt, 'it-IT');

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    PopupComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule
  ],
  exports: [
    LoaderComponent
  ],
  providers: [
    AuthGuard,
    HttpService,
    LoaderService,
    {
      provide: LOCALE_ID,
      useValue: 'it-IT' // 'de-DE' for Germany, 'fr-FR' for France ...
    }
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
}
